import routes from '@root/routes';
import Logo from '@components/shared/Logo';
import s from '@components/shared/Logo/Logo.module.less';

export default function LogoWrapper() {
  return (
    <div className={s.logoNavigationLink}>
      <a data-testid="homeLink" className={s.logo} href={routes.listingSearch()}>
        <Logo />
      </a>
    </div>
  );
}
